




























import { Component, Vue } from 'vue-property-decorator';
import Title from '@/components/Title.vue';
import IncomeReport from '@/components/reports/DailyIncomeReport.vue';
import ReportDate from '@/components/reports/DailyReportDate.vue';
import LevelMixin from '@/mixins/dailyIncomeReport.mixin';

@Component({
  components: { 
    Title, 
    IncomeReport, 
    ReportDate 
  },
  mixins: [LevelMixin]
})
export default class DIReport extends Vue {}
